<mat-dialog-content>
    <div class="w-full mb-5">
        <h3 class="text-center"> Do you want to replace existing challenge? </h3>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="-mb-4">
    <button mat-raised-button color="primary" mat-dialog-close tabindex="-1" (click)="onReplaceClick()" class="w-24">Replace</button>
    <button mat-raised-button class="w-24 bg-green text-contrast-white" tabindex="-1"  (click)="onAddClick()">Close</button>
</mat-dialog-actions>
